import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import LinkList from 'components/link-list/LinkList';

import { INavigationList } from 'source/NFR.types';

const NavigationList: React.FC<INavigationList> = ({ accordion, title, linkList }) => {
  return (
    <Accordion {...accordion} buttonTextForLabel={title}>
      {({ Button, Collapse, isOpen }) => (
        <div className="navigation-list">
          <Button
            icon="arrow-down"
            className={cn('navigation-list__toggle', {
              'navigation-list__toggle--is-active': isOpen
            })}
          >
            <span className="navigation-list__toggle-text">{title}</span>
          </Button>
          <Collapse className="navigation-list__content">
            <LinkList {...linkList} />
          </Collapse>
        </div>
      )}
    </Accordion>
  );
};

NavigationList.displayName = 'NavigationList';

export default NavigationList;
